import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lang]/not-found.tsx");
